import {
  Box,
  Typography,
  useTheme,
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  Button,
  MenuItem,
} from "@mui/material";
import Header from "../../components/Header";
const TokenGatingInfo = ({
  onHandleZoomNftTokenGatingDataInputChange,
  zoomNftTokenGatingData,
  handleRemoveClick,
  handleAddClick,
}) => {
  return (
    <Box m="40px" ml="70px">
      <Header
        title="Token Gating Configuration"
        subtitle="Provide Token Gating configuration"
      />
      <Grid container spacing={2}>
        {zoomNftTokenGatingData.map((currentElement, index) => {
          return (
            <Grid container key={index} direction="row">
              <Grid item md={3} sm={3} xs={3}>
                <FormControl
                  sx={{ ml: 3, mt: 2, boxShadow: 2 }}
                  fullWidth
                  required
                >
                  <InputLabel id="demo-simple-select-label">
                    Select BlockChain
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="blockChain"
                    label="Select BlockChain"
                    value={currentElement.blockChain}
                    onChange={(event) =>
                      onHandleZoomNftTokenGatingDataInputChange(event, index)
                    }
                  >
                    <MenuItem value={"Ethereum"}>Ethereum</MenuItem>
                    <MenuItem value={"Polygon"}>Polygon</MenuItem>
                    <MenuItem value={"POAP/xDai"}>POAP/xDAI</MenuItem>
                    <MenuItem value={"Sepolia-Ethereum"}>
                      Sepolia Ethereum
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={3} sm={3} xs={3}>
                <FormControl
                  sx={{ ml: 3.5, mt: 2, boxShadow: 2 }}
                  fullWidth
                  required
                >
                  <InputLabel id="demo-simple-select-label">
                    Token Standard
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="tokenStandard"
                    label="Enter Smart Contract Token Standard"
                    value={
                      currentElement.blockChain == "POAP/xDai"
                        ? (currentElement.tokenStandard = "ERC721")
                        : currentElement.tokenStandard
                    }
                    onChange={(event) =>
                      onHandleZoomNftTokenGatingDataInputChange(event, index)
                    }
                    disabled={
                      currentElement.blockChain == "POAP/xDai" ? true : false
                    }
                  >
                    <MenuItem value={"ERC721"}>ERC721</MenuItem>
                    <MenuItem value={"ERC1155"}>ERC1155</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={3} sm={3} xs={3}>
                <TextField
                  sx={{ ml: 4, mt: 2, boxShadow: 2 }}
                  fullWidth
                  required
                  name="contractAddress"
                  label={
                    currentElement.blockChain == "POAP/xDai"
                      ? "Event ID"
                      : "Contract Address"
                  }
                  variant="outlined"
                  type="text"
                  id="contractAddress"
                  value={currentElement.contractAddress}
                  onChange={(event) =>
                    onHandleZoomNftTokenGatingDataInputChange(event, index)
                  }
                />
              </Grid>
              <Grid item md={1} xs={1} sm={1}>
                {
                  <Button
                    disabled={
                      zoomNftTokenGatingData.length - 1 === index ? false : true
                    }
                    variant="contained"
                    sx={{ mt: 6, ml: 5, backgroundColor: "#6870fa" }}
                    onClick={handleAddClick}
                    color="info"
                  >
                    Add
                  </Button>
                }
              </Grid>
              <Grid item md={1} xs={1} sm={1}>
                {
                  <Button
                    disabled={zoomNftTokenGatingData.length == 1 ? true : false}
                    variant="contained"
                    sx={{ mt: 6, ml: 5 }}
                    onClick={() => handleRemoveClick(index)}
                    color="error"
                  >
                    Remove
                  </Button>
                }
              </Grid>
              <Grid item md={4.5} sm={4.5} xs={4.5}>
                <TextField
                  sx={{ ml: 3, boxShadow: 2 }}
                  fullWidth
                  name="tokenId"
                  variant="outlined"
                  value={currentElement.tokenId}
                  label="Token Id"
                  type="text"
                  id="tokenId"
                  onChange={(event) =>
                    onHandleZoomNftTokenGatingDataInputChange(event, index)
                  }
                />
              </Grid>
              <Grid item md={4.5} sm={4.5} xs={4.5}>
                <TextField
                  sx={{ ml: 3.9, boxShadow: 2 }}
                  fullWidth
                  required
                  name="nftsRequired"
                  variant="outlined"
                  label="Nfts Required"
                  inputProps={{ type: "number", min: 1 }}
                  id="nftsRequired"
                  value={currentElement.nftsRequired}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value === "" || value > 0) {
                      onHandleZoomNftTokenGatingDataInputChange(event, index);
                    }
                  }}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default TokenGatingInfo;
